import api from './api';

export const authService = {
  // Simple login for testing (bypasses OTP)
  simpleLogin: async (username, password) => {
    const response = await api.post('/auth/simple-login/', {
      username: username,
      password: password
    });
    return response.data;
  },

  // Send OTP for login (with credential verification)
  sendLoginOTP: async (emailOrPhone, password) => {
    const response = await api.post('/auth/send-login-otp/', {
      email_or_phone: emailOrPhone,
      password: password
    });
    return response.data;
  },

  // Verify login with OTP
  verifyLogin: async (emailOrPhone, password, otp) => {
    // Check if it's a staff member login
    const staffMembers = JSON.parse(localStorage.getItem('staffMembers') || '[]');
    const staffMember = staffMembers.find(staff => 
      (staff.email === emailOrPhone || staff.phone === emailOrPhone) && 
      staff.status === 'active'
    );
    
    if (staffMember) {
      // Verify staff credentials strictly
      if (staffMember.password !== password) {
        throw new Error('Invalid password');
      }
      
      // Verify OTP
      const storedOTP = localStorage.getItem('staff_otp_' + emailOrPhone);
      if (!storedOTP || storedOTP !== otp) {
        throw new Error('Invalid or expired OTP');
      }
      
      // Clean up OTP
      localStorage.removeItem('staff_otp_' + emailOrPhone);
      
      // Staff login success
      const mockResponse = {
        access: 'staff_token_' + Date.now(),
        user: {
          id: staffMember.id,
          username: staffMember.name,
          email: staffMember.email,
          phone: staffMember.phone,
          is_superuser: false,
          is_staff: true,
          specialization: staffMember.specialization,
          designation: staffMember.designation,
          assignedProjects: staffMember.assignedProjects || []
        }
      };
      return mockResponse;
    }
    
    // Regular user login
    const response = await api.post('/auth/verify-login/', {
      email_or_phone: emailOrPhone,
      password: password,
      otp: otp
    });
    return response.data;
  },

  // Register new user
  register: async (userData) => {
    const response = await api.post('/auth/register/', userData);
    return response.data;
  },

  // Send OTP for registration
  sendRegisterOTP: async (email, phone) => {
    const response = await api.post('/auth/send-register-otp/', {
      email: email,
      phone: phone
    });
    return response.data;
  },

  // Verify registration OTP
  verifyRegisterOTP: async (email, phone, otp) => {
    const response = await api.post('/auth/verify-register-otp/', {
      email: email,
      phone: phone,
      otp: otp
    });
    return response.data;
  },

  // Logout
  logout: async () => {
    try {
      await api.post('/auth/logout/');
    } finally {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userInfo');
    }
  },

  // Get user profile
  getProfile: async () => {
    const response = await api.get('/auth/profile/');
    return response.data;
  }
};